import React, { useState, useMemo } from 'react';
import './KeywordInput.scss';

// プレースホルダ候補（ここからランダムで3つ表示）
const TOPIC_WORDS = [
  '夏休み', 'ゲーム', '恋バナ', '部活', 'テスト', '修学旅行',
  'コンビニ', 'ラーメン', '宿題', '将来の夢', '好きな音楽', 'スマホ',
  '寝坊', '文化祭', 'お年玉', '幽霊', '宇宙人', 'タイムマシン',
  'コーヒー', '猫', '筋トレ', 'バイト', '初恋', '推し',
  '都市伝説', 'お菓子', '雨の日', '冬の朝', '放課後', '無人島',
];

function pickRandom(arr, n) {
  const copy = [...arr];
  const result = [];
  for (let i = 0; i < n && copy.length > 0; i++) {
    const idx = Math.floor(Math.random() * copy.length);
    result.push(copy.splice(idx, 1)[0]);
  }
  return result;
}

// onCancel を渡すと「やめる」が出る（会話中にポップアップで開いたとき用）。
// 渡さなければ初回のお題入力画面として振る舞う。
const KeywordInput = ({ onSubmit, onCancel, submitLabel = 'おしゃべりを始める ▸' }) => {
  const [keyword, setKeyword] = useState('');

  // マウント時に3つランダム選択
  const suggestions = useMemo(() => pickRandom(TOPIC_WORDS, 3), []);
  const placeholder = useMemo(() => `例：${suggestions.join('、')}...`, [suggestions]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      onSubmit(keyword);
    }
  };

  return (
    <div className="keyword-input">
      <div className="window">
        <div className="titlebar">
          <div className="dots">
            <i className="d1" />
            <i className="d2" />
            <i className="d3" />
          </div>
          <div className="ttl">BOKUBANA — TOPIC</div>
        </div>

        <div className="window-body">
          <div className="speech">お題をひとつ、お聞かせください</div>

          <h2 className="input-title">
            今日は<span className="hl">何の話</span>する？
          </h2>
          <p className="input-subtitle">お題を入れると、4人がゆるーく喋り出します</p>

          <form onSubmit={handleSubmit} className="keyword-form">
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder={placeholder}
              className="keyword-field"
              autoFocus
            />

            {/* 押すとその語が入るお題の候補 */}
            <div className="suggestions">
              <span className="suggestions-label">TRY</span>
              {suggestions.map((word) => (
                <button
                  key={word}
                  type="button"
                  className="chip"
                  onClick={() => setKeyword(word)}
                >
                  {word}
                </button>
              ))}
            </div>

            <button type="submit" className="btn big" disabled={!keyword.trim()}>
              {submitLabel}
            </button>

            {onCancel && (
              <button type="button" className="cancel" onClick={onCancel}>
                やめて、さっきの話に戻る
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default KeywordInput;
